import {Record, useListContext} from "ra-core";
import React from "react";
import {
    BooleanField,
    Datagrid,
    DateField,
    FunctionField,
    Link,
    linkToRecord,
    NumberField,
    ReferenceField,
    SelectField,
    TextField,
} from "react-admin";
import {IdentifierField} from "../components/IdentifierField";
import {DatagridPropsWithOptions} from "../shared/types";
import {initField} from "../shared/utils";
import {DownloadInvoiceDetailExcelButton} from "./components/DownloadInvoiceDetailExcelButton";
import {DownloadInvoiceDetailPdfButton} from "./components/DownloadInvoiceDetailPdfButton";
import {DownloadInvoicePdfButton} from "./components/DownloadInvoicePdfButton";
import {DownloadXmlButton} from "./components/DownloadXmlButton";
import {InvoiceStatusField} from "./components/InvoiceStatusField";

export const InvoiceDatagrid = ({
                                    options,
                                    ...rest
                                }: DatagridPropsWithOptions) => {
    const {refetch} = useListContext();

    return (
        <Datagrid {...rest}>
            <IdentifierField show {...initField("id", options)} />
            <FunctionField
                label="Azienda"
                source="company_object"
                render={(record: Record | undefined) => {
                    if (record && record.company_object) {
                        return (
                            <Link to={linkToRecord("/subjects", record.company_object.company.id, "edit")}>
                                <TextField
                                    record={record.company_object}
                                    source="name"
                                    variant="inherit"

                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="company__company__business_name"
            />
            <FunctionField
                label="Cliente"
                source="client_id"
                render={(record: Record | undefined) => {
                    if (record) {
                        return (
                            <Link to={linkToRecord("/subjects", record.client_id, "edit")}>
                                <TextField
                                    record={record.client}
                                    source="business_name"
                                    variant="inherit"
                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="client__business_name"
            />
            <InvoiceStatusField/>
            <SelectField
                {...initField("invoice_type", options, "array")}
                choices={options.invoice_type.choices}
            />
            <SelectField
                {...initField("type", options, "array")}
                choices={options.type.choices}
            />
            <NumberField {...initField("sequence_number", options)} label="Numero fattura"/>
            <DateField {...initField("invoice_date", options)} />
            <DateField {...initField("expiration_date", options)} />
            <DateField {...initField("invoice_sent", options)} showTime/>
            <TextField {...initField("email", options)} />
            <BooleanField {...initField("fixed_cost", options)} />
            <NumberField {...initField("taxable", options)} />
            <NumberField {...initField("amount", options)} />
            <ReferenceField
                {...initField("invoice_reference", options)}
                reference="invoices"
            >
                <FunctionField
                    render={(record: any) =>
                        `N° ${record.type}-${record.sequence_number}`
                    }
                />
            </ReferenceField>
            <DownloadXmlButton onSuccess={refetch}/>
            <DownloadInvoicePdfButton/>
            <DownloadInvoiceDetailExcelButton/>
            <DownloadInvoiceDetailPdfButton/>
        </Datagrid>
    );
};
